import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import RouterConstants from "../../constants/RouterConstants";
import TabsLayout, { ITabLayout } from "../../layout/TabsLayout/TabsLayout";
import styles from "./VideoEditing.module.scss";

const VideoEditing = () => {
	const { t } = useTranslation("translation", { keyPrefix: "videoEditing" });
	const subTabs: ITabLayout[] = [
		{ name: t("overview.tab"), link: RouterConstants.VIDEO_EDITING.OVERVIEW.path },
		{ name: t("api.tab"), link: RouterConstants.VIDEO_EDITING.API.path },
	];

	return (
		<TabsLayout contentClassName={styles.content} title={t("header")} subTabs={subTabs}>
			<Outlet />
		</TabsLayout>
	);
};

export default observer(VideoEditing);
